export const translations = {
  en: {
    // Header
    'nav.home': 'Home',
    'nav.influencers': 'Influencers',
    'nav.billboards': 'Billboards',
    'nav.digitalads': 'Digital Ads',
    'nav.kannywood': 'Kannywood',
    'nav.signin': 'Sign In',
    'nav.signup': 'Sign Up',
    'nav.dashboard': 'Dashboard',
    'nav.logout': 'Logout',
    'nav.buildcampaign': 'Get a Consultation',

    // Hero
    'hero.title': 'Book trusted ads across Northern Nigeria',
    'hero.subtitle': 'Connect with verified influencers, premium billboards, and Kannywood placements — all in one trusted marketplace.',
    'hero.cta1': 'Browse Influencers',
    'hero.cta2': 'Book a Billboard',
    'hero.cta3': 'Get a Consultation',

    // Categories
    'cat.influencers': 'Influencers',
    'cat.influencers.desc': 'Reach Northern Nigerian audiences through trusted creators.',
    'cat.billboards': 'Billboards',
    'cat.billboards.desc': 'Premium outdoor advertising across major cities.',
    'cat.digitalads': 'Digital Ads',
    'cat.digitalads.desc': 'Managed campaigns on Facebook, Instagram, Google & more.',
    'cat.kannywood': 'Kannywood',
    'cat.kannywood.desc': 'Product placements in Northern Nigerian cinema.',

    // Trust
    'trust.title': 'Why Adlinka Ads Network?',
    'trust.verified': 'Verified Suppliers',
    'trust.verified.desc': 'All suppliers undergo identity and business verification.',
    'trust.escrow': 'Secure Payments',
    'trust.escrow.desc': 'Funds held in escrow until delivery is confirmed.',
    'trust.dispute': 'Dispute Resolution',
    'trust.dispute.desc': 'Fair mediation process for any issues.',

    // Auth
    'auth.login': 'Log In',
    'auth.register': 'Create Account',
    'auth.email': 'Email',
    'auth.password': 'Password',
    'auth.name': 'Full Name',
    'auth.phone': 'Phone Number',
    'auth.role': 'I am a...',
    'auth.advertiser': 'Advertiser',
    'auth.supplier': 'Supplier',
    'auth.submit': 'Continue',

    // Common
    'common.loading': 'Loading...',
    'common.search': 'Search',
    'common.filter': 'Filter',
    'common.sort': 'Sort',
    'common.price': 'Price',
    'common.location': 'Location',
    'common.verified': 'Verified',
    'common.reviews': 'reviews',
    'common.starting': 'Starting at',
    'common.perpost': 'per post',
    'common.permonth': 'per month',
    'common.bookNow': 'Book Now',
    'common.viewDetails': 'View Details',
    'common.contactUs': 'Contact Us',

    // Footer
    'footer.about': 'About',
    'footer.pricing': 'Pricing',
    'footer.faq': 'FAQ',
    'footer.contact': 'Contact',
    'footer.terms': 'Terms of Service',
    'footer.privacy': 'Privacy Policy',
    'footer.copyright': '© 2026 Adlinka Ads Network. All rights reserved.',
  },
  ha: {
    // Header
    'nav.home': 'Gida',
    'nav.influencers': 'Masu Tasiri',
    'nav.billboards': 'Allunan Talla',
    'nav.digitalads': 'Tallan Dijital',
    'nav.kannywood': 'Kannywood',
    'nav.signin': 'Shiga',
    'nav.signup': 'Yi Rajista',
    'nav.dashboard': 'Dashboard',
    'nav.logout': 'Fita',
    'nav.buildcampaign': 'Nemi Shawara',

    // Hero
    'hero.title': 'Yi tallace-tallacen da aka amintar a Arewacin Najeriya',
    'hero.subtitle': 'Haɗa kai da masu tasiri da aka tabbatar, alluna masu kyau, da wuraren Kannywood — duk a cikin kasuwa guda ɗaya.',
    'hero.cta1': 'Bincika Masu Tasiri',
    'hero.cta2': 'Yi Ajiyar Allon Talla',
    'hero.cta3': 'Nemi Shawara',

    // Categories
    'cat.influencers': 'Masu Tasiri',
    'cat.influencers.desc': 'Kai ga masu sauraro ta hanyar masu ƙirƙira da aka tabbatar.',
    'cat.billboards': 'Allunan Talla',
    'cat.billboards.desc': 'Tallan waje mai kyau a manyan biranen.',
    'cat.digitalads': 'Tallan Dijital',
    'cat.digitalads.desc': 'Kamfen da ake sarrafa akan Facebook, Instagram, Google da sauransu.',
    'cat.kannywood': 'Kannywood',
    'cat.kannywood.desc': 'Sanya samfura a cikin fina-finan Arewacin Najeriya.',

    // Trust
    'trust.title': 'Me yasa Adlinka Ads Network?',
    'trust.verified': 'Masu Bada Sabis Da Aka Tabbatar',
    'trust.verified.desc': 'Duk masu bada sabis suna ta samun tantancewa.',
    'trust.escrow': 'Biya Mai Tsaro',
    'trust.escrow.desc': 'Ana riƙe kuɗi har sai an tabbatar da bayarwa.',
    'trust.dispute': 'Warware Rikici',
    'trust.dispute.desc': 'Tsarin sulhu mai adalci don kowane matsala.',

    // Auth
    'auth.login': 'Shiga',
    'auth.register': 'Ƙirƙiri Asusun',
    'auth.email': 'Imel',
    'auth.password': 'Kalmar Sirri',
    'auth.name': 'Cikakken Suna',
    'auth.phone': 'Lambar Waya',
    'auth.role': 'Ni...',
    'auth.advertiser': 'Mai Talla',
    'auth.supplier': 'Mai Bada Sabis',
    'auth.submit': 'Ci gaba',

    // Common
    'common.loading': 'Ana lodawa...',
    'common.search': 'Bincike',
    'common.filter': 'Tace',
    'common.sort': 'Tsarawa',
    'common.price': 'Farashi',
    'common.location': 'Wurin',
    'common.verified': 'An Tabbatar',
    'common.reviews': 'sako',
    'common.starting': 'Ana farawa da',
    'common.perpost': 'kowane aiki',
    'common.permonth': 'kowane wata',
    'common.bookNow': 'Yi Ajiya Yanzu',
    'common.viewDetails': 'Duba Cikakken Bayani',
    'common.contactUs': 'Tuntube Mu',

    // Footer
    'footer.about': 'Game da mu',
    'footer.pricing': 'Farashi',
    'footer.faq': 'Tambayoyi',
    'footer.contact': 'Tuntube Mu',
    'footer.terms': 'Sharuɗɗan Sabis',
    'footer.privacy': 'Manufar Sirri',
    'footer.copyright': '© 2026 Adlinka Ads Network. Dukkanin haƙƙoƙin sun keɓe.',
  },
};

export const t = (key, lang = 'en') => {
  return translations[lang]?.[key] || translations.en[key] || key;
};
